import { createRouter, createWebHashHistory } from "vue-router"

import Home from "../views/Home.vue"
import Topic from "../views/Topic.vue"
import Subject from "../views/Subject.vue"

const routes = [
  { path: "/", name: "Home", component: Home },
  { path: "/topic/:id", name: "Topic", component: Topic },
  { path: "/subject/:id", name: "Subject", component: Subject },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

export default router
